import { t } from "@hakili/i18n";
import { User } from "lucide-react";

import type { Vue } from "./views.js";

/**
 * `round CN-A`, `CN-A.0`: **the scope banner, `hakili-console.jsx`'s
 * `PorteeBanner`.**
 *
 * Under the person's name and role, what this role does and , as importantly ,
 * what it does NOT. The drawing puts it at the top of the screen, above
 * everything, and it is the first thing a person reads when they sign in as
 * somebody they have not been before.
 *
 * **The administration has none, and that is the drawing's own decision**:
 * `portee: null`. A scope that is everything is not a scope, and a paragraph
 * saying so would be noise on the one view that has no boundary to state.
 *
 * The words are the founder's, in the catalogue, to the letter , a paraphrase
 * of a boundary is a different boundary.
 */
const PORTEE_KEY: Readonly<Record<Vue, string | null>> = {
  admin: null,
  resp: "console.portee.resp",
  collecte: "console.portee.collecte",
  banques: "console.portee.banques",
  concess: "console.portee.concess",
};

export interface PorteeBannerProps {
  readonly vue: Vue;
  /**
   * The person, from `/me`. The drawing prints « Nom · Rôle. » before the
   * scope, and the rôle is the VIEW's label (`vue.label`), never the wire key
   * , « responsableDossiers » is a string for the door, not for the person.
   */
  readonly personne: string;
}

export function PorteeBanner({ vue, personne }: PorteeBannerProps): React.JSX.Element | null {
  const key = PORTEE_KEY[vue];
  if (key === null) return null;
  return (
    <div
      data-testid="console-portee"
      className="mb-6 flex items-start gap-3 rounded-2xl border border-gray-200 bg-white px-5 py-3"
    >
      {/* The drawing's own icon, by name , `OD-19` closed at Round F2. */}
      <User className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
      <p className="text-sm leading-relaxed text-gray-500">
        <span className="font-medium text-gray-700">
          {personne} · {t(`console.vue.${vue}`)}.{" "}
        </span>
        {t(key)}
      </p>
    </div>
  );
}
